import { doc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

// ── users 컬렉션 ──

export const getUserProfile = async (uid) => {
  const snap = await getDoc(doc(db, 'users', uid));
  if (!snap.exists()) return null;
  return { uid: snap.id, ...snap.data() };
};

export const updateUserProfile = async (uid, data) => {
  await updateDoc(doc(db, 'users', uid), {
    ...data,
    updatedAt: serverTimestamp(),
  });
};

// ── realtors 컬렉션 ──

export const getRealtorProfile = async (uid) => {
  const snap = await getDoc(doc(db, 'realtors', uid));
  if (!snap.exists()) return null;
  return { uid: snap.id, ...snap.data() };
};

export const updateRealtorProfile = async (uid, data) => {
  await updateDoc(doc(db, 'realtors', uid), {
    ...data,
    updatedAt: serverTimestamp(),
  });
};
